import { render, staticRenderFns } from "./AwardTypeEdit.vue?vue&type=template&id=17900e22"
import script from "./AwardTypeEdit.vue?vue&type=script&lang=js"
export * from "./AwardTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports